<div class="padding-16 gap-16 flex-horizontal background-valid-pastel rounded">
  <oui-icon class="color-valid">task</oui-icon>
  <div class="flex-vertical gap-4">
    <div class="subtitle-1 color-valid">Déclaré conforme</div>
    @if (latestConformity?.initiatorBackOffice) {
      <div class="caption color-on-surface-medium">
        par {{ latestConformity?.initiatorBackOffice?.displayName }}
      </div>
    }
    @if (latestConformity?.timestamp) {
      <div class="caption color-on-surface-medium">
        le {{ $safeNavigationMigration(latestConformity?.timestamp) | date: 'dd/MM/yyyy' }} à {{ $safeNavigationMigration(latestConformity?.timestamp) | date: 'HH:mm' }}
      </div>
    }
  </div>
</div>
